import React from 'react';
import { alpha, Toolbar, Typography } from '@mui/material';

interface Props {
  numSelected: number;
  title: string;
  children: JSX.Element
}

export const TableHeaderToolbar: React.FC<Props> = (props) => {
  const { numSelected, title, children } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography 
          sx={{flex: '1 1 100%'}}
          color="inherit" 
          variant={'subtitle1'} 
          component="div"
        >
          {numSelected} Selecionados
        </Typography>
      ) : (
        <Typography 
          sx={{flex: '1 1 100%'}}
          variant="h6" 
          id="tableTitle" 
          component="div"
        >
          {title}
        </Typography>
      )}
      {children}
      {/* 
        Example of Children
        <Tooltip title="Filtrar">
            <IconButton aria-label="filter list">
              <FilterListIcon />
            </IconButton>
        </Tooltip> */}
    </Toolbar>
  );
};
